export const canUseBrowserNotifications = () =>
  typeof window !== "undefined" && "Notification" in window;

export const requestBrowserNotificationPermission = async () => {
  if (!canUseBrowserNotifications()) return "unsupported";
  if (!window.isSecureContext) return "denied";
  if (Notification.permission === "default") {
    return Notification.requestPermission();
  }
  return Notification.permission;
};

export const createAppNotification = async ({
  title,
  body,
  icon,
  tag,
  renotify = true,
  url = "/",
  onClick,
}) => {
  if (!canUseBrowserNotifications()) return null;
  if (Notification.permission !== "granted") return null;

  const options = {
    body,
    icon,
    tag,
    renotify,
    data: { url },
  };

  try {
    const notification = new Notification(title, options);
    if (typeof onClick === "function") {
      notification.onclick = onClick;
    }
    return notification;
  } catch (error) {
    if (!("serviceWorker" in navigator)) return null;
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.showNotification(title, options);
      return null;
    } catch (swError) {
      return null;
    }
  }
};
